import "./blog-hero.css";

export default function BlogHero() {
  return (
    <section className="oglitz-blog-hero">
      {/* Optional animated background layers */}
      <div className="oglitz-blog-hero__glow" />
      <div className="oglitz-blog-hero__particles">
        <span />
        <span />
        <span />
        <span />
      </div>

      <div className="oglitz-blog-hero__container">
        <span className="oglitz-blog-hero__badge">INSIGHTS & ARTICLES</span>

        <h1 className="oglitz-blog-hero__title">
          Oglitz <span>Blogs</span>
        </h1>

        <p className="oglitz-blog-hero__subtitle">
          Expert insights on software development, cloud engineering, UI/UX
          design, and digital transformation.
        </p>
      </div>
    </section>
  );
}
